document.addEventListener('DOMContentLoaded', () => {
  const data = document.getElementById('shopify-app-init').dataset;

  if (data.page) {
    let titleBar = document.querySelector('ui-title-bar');
    if (!titleBar) {
      titleBar = document.createElement('ui-title-bar');
      document.body.appendChild(titleBar);
    }
    titleBar.setAttribute('title', data.page);
  }
});
